import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RiskHome, RiskHow, RiskPricing, RiskSample, RiskContact, RiskLegalTerms, RiskLegalPrivacy, RiskConfirm } from './pages/risk-site/RiskSite';

// Workspace code, auth clients and workspace styling are loaded on demand.
const WorkspaceApp = lazy(() => import('./App'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><BrowserRouter><Suspense fallback={<main role="status" style={{ padding: 32 }}>Ladataan…</main>}><Routes>
  <Route path="/" element={<RiskHome />} />
  <Route path="/how-it-works" element={<RiskHow />} />
  <Route path="/pricing" element={<RiskPricing />} />
  <Route path="/sample-dossier" element={<RiskSample />} />
  <Route path="/contact" element={<RiskContact />} />
  <Route path="/contact/confirm" element={<RiskConfirm />} />
  <Route path="/legal/terms" element={<RiskLegalTerms />} />
  <Route path="/legal/privacy" element={<RiskLegalPrivacy />} />
  <Route path="/terms" element={<RiskLegalTerms />} />
  <Route path="/privacy" element={<RiskLegalPrivacy />} />
  <Route path="*" element={<WorkspaceApp embedded />} />
</Routes></Suspense></BrowserRouter></React.StrictMode>);
